"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStatesOptions = void 0;
var _react = require("react");
var _useTranslation2 = require("../../../../hooks/useTranslation/useTranslation");
var _states = require("../../../../constants/states/states");
var useStatesOptions = function useStatesOptions() {
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  var options = (0, _react.useMemo)(function () {
    return _states.STATES.map(function (_ref) {
      var code = _ref.code;
      return {
        label: {
          text: t("states.".concat(code))
        },
        value: code
      };
    });
  }, [t]);
  return options;
};
exports.useStatesOptions = useStatesOptions;